import { useCallback, useState, useRef } from 'react';
import { GetToken } from '@utils/storage';
import * as config from '@config';

function useRideQuote() {
    const [submitting, setSubmitting] = useState(false);
    const [data, setData] = useState({});

    const abortRef = useRef();

    const handleRideQuote = useCallback(async (req) => {
        abort();
        setSubmitting(true);
        abortRef.current = new AbortController();
        console.log('Requesting ride quote:', req);

        try {
            const response = await fetch(`${config.apiURL2}/ride/quote`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${GetToken()}`,
                },
                body: JSON.stringify(req),
                signal: abortRef.current.signal,
            });
            if (!response.ok) {
                const data = await response.json();
                throw new Error(data.error || 'An error occurred while fetching ride quote');
            }
            const data = await response.json();
            const { quote } = data;
            setData(quote);
            return data;
        } catch (error) {
            if (error.name === 'AbortError') {
                console.log('Request was aborted');
                throw new Error('Request was aborted');
            } else {
                console.error('Error fetching ride quote:', error);
            }
            throw error;
        } finally {
            setSubmitting(false);
        }
    }, []);

    const abort = useCallback(() => {
        if (abortRef.current) {
            abortRef.current.abort();
        }
    }, []);

    return { submitting, handleRideQuote, data, abort };
}

export default useRideQuote;
